import React, { ChangeEvent, useState } from 'react';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import { useForm } from 'react-hook-form';
import SubmitButton from '../../../../Components/Button/SubmitButton';
import { DeepPartial } from '../../../../Interfaces/DeepPartial';
import styles from './CSSZSickLeaveCertificateReturnAdmissionRequestForm.module.scss';
import DateField from '../../../../Components/Form/components/DateField';
import TextAreaField from '../../../../Components/Form/components/TextAreaField';
import FileUpload from '../../../../Components/Base/FileUpload/FileUpload';
import FormControl from '../../../../Components/Form/FormControl';
import InputWrapper from '../../../../Components/Form/components/InputWrapper/InputWrapper';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

export interface CSSZSickLeaveCertificateReturnAdmissionRequestFormValues {
	issuedAt: string;
	issuedOn: string;
	note: string;
	file?: File;
}

interface Props {
	onSubmit: (
		values: CSSZSickLeaveCertificateReturnAdmissionRequestFormValues,
	) => void;
	defaultValues?: DeepPartial<CSSZSickLeaveCertificateReturnAdmissionRequestFormValues>;
}

const validationSchema = yup.object({
	issuedAt: yup
		.string()
		.nullable()
		.required(
			'validation.CSSZSickLeaveCertificateReturnAdmissionRequestForm.issuedAt',
		),
	issuedOn: yup
		.string()
		.nullable()
		.required(
			'validation.CSSZSickLeaveCertificateReturnAdmissionRequestForm.issuedOn',
		),
	note: yup
		.string()
		.nullable()
		.required(
			'validation.CSSZSickLeaveCertificateReturnAdmissionRequestForm.note',
		),
});

const CSSZSickLeaveCertificateReturnAdmissionRequestForm: React.FC<Props> = ({
	onSubmit,
	defaultValues,
}) => {
	const [selectedFile, setSelectedFile] = useState<File | undefined>();
	const formMethods = useForm({
		defaultValues,
		resolver: yupResolver(validationSchema),
	});

	const handleChangeFile = (event: ChangeEvent<HTMLInputElement>) => {
		setSelectedFile(event.target.files?.[0]);
	};

	const handleSubmit = (
		values: CSSZSickLeaveCertificateReturnAdmissionRequestFormValues,
	) => {
		onSubmit({
			...values,
			file: selectedFile,
		});
	};

	return (
		<FormWrapper formMethods={formMethods}>
			<div className={styles.inline}>
				<DateField
					name='issuedAt'
					label='component.CSSZSickLeaveCertificateReturnAdmissionRequest.issuedAt'
					isRequired
					isWrapped
					isDisabled
				/>
				<DateField
					name='issuedOn'
					label='component.CSSZSickLeaveCertificateReturnAdmissionRequest.issuedOn'
					isRequired
					isWrapped
				/>
			</div>
			<TextAreaField
				name='note'
				label='component.CSSZSickLeaveCertificateReturnAdmissionRequest.note'
				isRequired
				isWrapped
			/>
			<InputWrapper>
				<FormControl
					label='component.CSSZSickLeaveCertificateReturnAdmissionRequest.file'
					name='file'
					onChange={handleChangeFile}
					isRequired>
					<FileUpload />
				</FormControl>
			</InputWrapper>
			<div className='mt-3'>
				<SubmitButton onSubmit={handleSubmit} />
			</div>
		</FormWrapper>
	);
};

export default CSSZSickLeaveCertificateReturnAdmissionRequestForm;
